import React from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../components/Layout';
import BigButton from '../components/BigButton';
import { numbersData } from '../data/numbers';
import { useSpeech } from '../hooks/useSpeech';
import './Alphabets.css'; // Reuse grid styles

const Numbers = () => {
    const history = useHistory();
    const { speak } = useSpeech();

    const handleNumberClick = (item) => {
        speak(item.label);
        setTimeout(() => {
            history.push(`/numbers/${item.value}`);
        }, 400);
    };

    return (
        <Layout title="Numbers 1-20" onBack={() => history.push('/')}>
            <div className="alphabets-grid">
                {numbersData.map((item) => (
                    <BigButton
                        key={item.value}
                        label={item.label}
                        color={item.color}
                        onClick={() => handleNumberClick(item)}
                        className="alphabet-button"
                    />
                ))}
            </div>
        </Layout>
    );
};

export default Numbers;
